<template>
  <b-container>
    <b-row>
      <b-col class="pt-2">
        <label>User</label>
        <treeselect
          v-model="filters.user_id"
          :async="true"
          :load-options="searchUser"
          :defaultOptions="true"
          :normalizer="normalizerUser" />
      </b-col>
      <div class="separacion w-100"></div>
      <b-col class="pt-2">
        <label>Facility</label>
        <treeselect
          v-model="filters.facilities_id"
          :options="facilityOptions"
          :normalizer="normalizer"
          multiple />
      </b-col>
      <div class="separacion w-100"></div>
      <b-col class="pt-2">
        <label>Facility</label>
        <treeselect
          v-model="filters.facility_id"
          :options="facilityOptions"
          :normalizer="normalizer"
          placeholder="Opcional · alternativa a varias facilities" />
      </b-col>
      <div class="separacion w-100"></div>
      <b-col class="pt-2">
        <label>Doctor</label>
        <treeselect
          v-model="filters.doctor_id"
          :async="true"
          :load-options="searchDoctor"
          :defaultOptions="true"
          :normalizer="normalizerUser" />
      </b-col>
      <div class="separacion w-100"></div>
    </b-row>
    <b-row>
      <b-col class="pt-2">
        <label>Rol</label>
        <treeselect
          v-model="filters.rol_id"
          :options="rolOptions"
          :normalizer="normalizer">
        </treeselect>
      </b-col>
      <div class="separacion w-100"></div>
      <b-col class="pt-2">
        <label>Start date</label>
        <flat-pickr
          v-model="filters.start_date"
          :config="config"
          class="form-control"
          placeholder="MM-DD-YYYY"
          type="date" />
      </b-col>
      <div class="separacion w-100"></div>
      <b-col class="pt-2">
        <label>End date</label>
        <flat-pickr
          v-model="filters.end_date"
          :config="configEnd"
          class="form-control"
          placeholder="MM-DD-YYYY"
          type="date" />
      </b-col>
      <b-col cols="12" class="mb-md-0 mb-2 mt-2" align="end">
        <b-button variant="secondary" @click="seeCuponsBool = true" class="mr-1">
          See cupons
        </b-button>
        <b-button variant="info" @click="seeCompareFacilities = true" class="mr-1">
          Compare facilities
        </b-button>
        <b-button variant="success" @click="emitExcel" class="mr-1" :disabled="isAnyLoading">
          <span v-if="!loadingExcel">Excel</span>
          <span v-else>
            <SpinnerLoading />
          </span>
        </b-button>
        <b-button variant="warning" @click="resetFilter" class="mr-1"> Clear </b-button>
        <b-button variant="primary" @click="handleFormSubmit()" :disabled="isAnyLoading">
          <span v-if="!loadingSearh">Search</span>
          <span v-else>
            <SpinnerLoading />
          </span>
        </b-button>
      </b-col>
    </b-row>
    <compareFacilities
      v-if="seeCompareFacilities"
      :seeCompareFacilities.sync="seeCompareFacilities" />
    <ToastNotification ref="toast" />
    <Cupons
      ref="tablarda"
      :tableData="tableData"
      @paginated="cuponsPage = $event"
      :seeCupons.sync="seeCupons"
      @sendDataTable="dataTable = $event" />
    <SeeCupons
      :cupons="cupons"
      :isCuponsModalActive.sync="seeCuponsBool"
      @closeModalCupons="closeModalCupons"
      @changePage="cuponsPage = $event" />

    <ProgressiveLoader
      :showLoader="showLoader"
      :loaderTitle="loaderTitle"
      :combining="loader.combining"
      :currentProgress="loader.currentProgress"
      :totalMonths="loader.totalMonths"
      :currentMonth="loader.currentMonth"
      :currentYear="loader.currentYear"
      :allowCancel="loader.allowCancel"
      @cancel="cancelProgressiveLoading"
    />
  </b-container>
</template>

<script>
import {
  BContainer,
  BRow,
  BCol,
  BButton,
} from 'bootstrap-vue'

import SpinnerLoading from '@/components/SpinnerLoading'
import ToastNotification from '@/components/ToastNotification'
import axios from '@/core/services/api/admin/adminData'
import progressiveAdminDataLoader from '@/core/services/api/admin/progressiveAdminDataLoader'
import axiosU from '@/core/services/api/admin/user'
import axiosR from '@/core/services/api/admin/roles'
import { getFacilityOptionsFromStorage } from '@/core/utils/facilityOptionsFromStorage'
import {
  buildExcelPayloadFromAdminData,
  hasAdminDataForExcel,
} from '@/core/utils/adminDataExcelExport'
import compareFacilities from './compareFacilities.vue'
import Cupons from './cupons.vue'
import SeeCupons from './seeCupons.vue'
import ProgressiveLoader from '@/view/pages/dashboard/components/ProgressiveLoader.vue'

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BButton,
    SpinnerLoading,
    ToastNotification,
    compareFacilities,
    Cupons,
    SeeCupons,
    ProgressiveLoader,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Number,
      default: 1,
      required: true,
    },
  },
  data() {
    return {
      rolOptions: [],
      facilityOptions: [],
      seeCuponsBool: false,
      loadingExcel: false,
      loadingSearh: false,
      cupons: [],
      showLoader: false,
      loader: {
        currentProgress: 0,
        totalMonths: 0,
        currentMonth: 0,
        currentYear: 0,
        allowCancel: true,
        combining: false,
      },
      filters: {
        user_id: null,
        facilities_id: null,
        facility_id: null,
        doctor_id: null,
        rol_id: null,
        end_date: null,
        start_date: null,
        data_excel: false,
      },
      config: {
        dateFormat: 'm-d-Y H:i:S',
        enableSeconds: true,
        allowInput: true,
        enableTime: true,
      },
      configEnd: {
        dateFormat: 'm-d-Y H:i:S',
        enableSeconds: true,
        allowInput: true,
        enableTime: true,
      },
      tableData: {},
      dataExcel: {},
      seeCompareFacilities: false,
      seeCupons: false,
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
      normalizerUser(node) {
        return {
          id: node.id,
          label: `${node.name} ${node.lastname}`,
        }
      },
      cuponsPage: 1,
      progressiveRunId: 0,
      loaderTitle: 'Loading Data Progressively',
      lastSearchFiltersKey: null,
    }
  },
  computed: {
    isAnyLoading() {
      return this.loadingSearh || this.loadingExcel || this.showLoader
    },
  },
  async created() {
    const firstDate = `${new Date().getMonth() + 1}-${new Date().getDate()}-${new Date().getFullYear()}`

    this.filters.start_date = `${firstDate} 09:00:00`
    this.filters.end_date = `${firstDate} 22:00:00`

    this.facilityOptions = getFacilityOptionsFromStorage()
    axiosR.rolesList().then(({ data }) => (this.rolOptions = data))

    this.searchFilter()
  },
  watch: {
    page() {
      if (this.isProgressiveResult()) {
        this.loadProgressivePage(this.page, { rows: true })
        return
      }
      axios
        .getAdminDataPaginated(this.page, this.filtersForApi(), { throwOnError: true })
        .then(({ data }) => {
          data.user = this.filters.user_id
          data.dates = {
            end_date: this.filters.end_date,
            start_date: this.filters.start_date,
          }
          this.setCupons(data['CAMPAIGN_CUPONS'])
          this.sendData(data)
        })
        .catch(error => this.showApiError(error))
    },
    cuponsPage() {
      if (this.isProgressiveResult()) {
        this.loadProgressivePage(this.cuponsPage, { rows: false, campaigns: true })
        return
      }
      axios
        .getAdminDataPaginated(this.cuponsPage, this.filtersForApi(), { throwOnError: true })
        .then(({ data }) => {
          data.user = this.filters.user_id
          data.dates = {
            end_date: this.filters.end_date,
            start_date: this.filters.start_date,
          }
          this.setCupons(data['CAMPAIGN_CUPONS'])
          this.tableData = data
        })
        .catch(error => this.showApiError(error))
    },
  },
  methods: {
    filtersForApi() {
      return { ...this.filters }
    },
    showApiError(error) {
      const message = error?.response?.data?.message
      this.$refs.toast?.danger?.(message || 'An unexpected error has been ocurred!')
    },
    /** El resultado en pantalla vino de una carga progresiva (rango de más de un mes). */
    isProgressiveResult() {
      const dates = this.tableData?.dates
      if (!dates?.start_date || !dates?.end_date) return false
      return (
        progressiveAdminDataLoader.calculateMonthsBetween(dates.start_date, dates.end_date) > 1
      )
    },
    /** Cambia de página sin pedir el rango completo, que el backend no responde. */
    async loadProgressivePage(page, targets) {
      try {
        const result = await progressiveAdminDataLoader.loadPage(page, targets)
        const data = { ...this.tableData }
        if (result.ROWS_PAGINATE) data.ROWS_PAGINATE = result.ROWS_PAGINATE
        if (result.CAMPAIGN_CUPONS) {
          const campaigns = { ...(data.CAMPAIGN_CUPONS || {}) }
          Object.entries(result.CAMPAIGN_CUPONS).forEach(([key, value]) => {
            campaigns[key] = { ...(campaigns[key] || {}), CUPONS_PAGINATE: value.CUPONS_PAGINATE }
          })
          data.CAMPAIGN_CUPONS = campaigns
          this.setCupons(campaigns)
        }
        if (targets.rows) this.sendData(data)
        else this.tableData = data
      } catch (error) {
        this.showApiError(error)
      }
    },
    getFiltersCacheKey() {
      return JSON.stringify({
        start_date: this.filters.start_date,
        end_date: this.filters.end_date,
        user_id: this.filters.user_id,
        facilities_id: this.filters.facilities_id,
        facility_id: this.filters.facility_id,
        doctor_id: this.filters.doctor_id,
        rol_id: this.filters.rol_id,
      })
    },
    isSearchCacheValid(cacheKey = this.getFiltersCacheKey()) {
      return (
        this.lastSearchFiltersKey === cacheKey &&
        this.tableData &&
        Object.keys(this.tableData).length > 0
      )
    },
    parseAdminDataResponse(response) {
      if (!response) return null
      return response.data != null ? response.data : response
    },
    setCupons(campaign_cupons) {
      const newCupons = []
      Object.entries(campaign_cupons || {}).forEach(([key, value]) => {
        value.title = key
        newCupons.push(value)
      })
      this.cupons = newCupons
    },
    closeModalCupons() {
      this.seeCuponsBool = false
    },
    sendData(data) {
      this.tableData = data
      this.$emit('getItems', data)
    },
    resetProgressiveUiState() {
      this.loadingSearh = false
      this.loadingExcel = false
      this.showLoader = false
      this.loader.currentProgress = 0
      this.loader.totalMonths = 0
      this.loader.currentMonth = 0
      this.loader.currentYear = 0
      this.loader.combining = false
      this.loader.allowCancel = true
      this.loaderTitle = 'Loading Data Progressively'
    },
    beginProgressiveRun() {
      progressiveAdminDataLoader.requestAbort()
      this.progressiveRunId += 1
      const runId = this.progressiveRunId

      this.resetProgressiveUiState()
      this.loaderTitle = 'Loading Data Progressively'
      this.showLoader = true
      return runId
    },
    attachProgressHandler() {
      progressiveAdminDataLoader.onProgress(
        ({ current, total, currentMonth, currentYear, phase }) => {
          this.$set(this.loader, 'currentProgress', current)
          this.$set(this.loader, 'totalMonths', total)
          this.$set(this.loader, 'currentMonth', currentMonth)
          this.$set(this.loader, 'currentYear', currentYear)
          this.$set(this.loader, 'combining', phase === 'combining')
          if (phase === 'combining') {
            this.loaderTitle = 'Merging monthly data...'
          }
        }
      )
    },
    applyAdminDataResult(data) {
      if (!data) return

      data.facility = this.filters.facilities_id
      data.user = this.filters.user_id
      data.dates = {
        end_date: this.filters.end_date,
        start_date: this.filters.start_date,
      }

      this.lastSearchFiltersKey = this.getFiltersCacheKey()
      this.setCupons(data['CAMPAIGN_CUPONS'] || {})
      this.sendData(data)
    },
  /**
   * Paso 2 del Excel: transforma datos ya cargados y dispara la descarga.
   * No hace ninguna llamada al API.
   */
    finalizeExcelExport(adminData) {
      const payload = buildExcelPayloadFromAdminData(adminData)
      if (!payload.DATA_EXCEL.length) {
        this.$refs.toast?.warning?.('No consult rows available for Excel export.')
        return
      }

      this.dataExcel = payload
      this.$emit('dataExcel', payload)

      this.$nextTick(() => {
        this.$emit('getExcel')
      })
    },
  /**
   * Misma carga progresiva que Search (único proceso de datos).
   * @returns {Promise<object|null>}
   */
    async loadAdminDataProgressive(runId) {
      await progressiveAdminDataLoader.waitUntilIdle()
      if (runId !== this.progressiveRunId) return null

      this.attachProgressHandler()

      const combinedData = await progressiveAdminDataLoader.loadProgressiveData(
        {
          ...this.filtersForApi(),
          data_excel: false,
        },
        false
      )

      if (runId !== this.progressiveRunId) return null
      this.applyAdminDataResult(combinedData)
      return combinedData
    },
    async loadAdminDataSingleRequest() {
      const response = await axios.getAdminData(
        {
          ...this.filtersForApi(),
          data_excel: false,
        },
        { throwOnError: true }
      )
      const data = this.parseAdminDataResponse(response)
      this.applyAdminDataResult(data)
      return data
    },
    async runProgressiveSearch() {
      const runId = this.beginProgressiveRun()
      this.loadingSearh = true

      try {
        await this.loadAdminDataProgressive(runId)
      } catch (err) {
        if (runId !== this.progressiveRunId) return
        if (String(err?.message) !== 'ABORTED_BY_USER') {
          this.showApiError(err)
        }
      } finally {
        if (runId === this.progressiveRunId) {
          progressiveAdminDataLoader.resetFlagsOnly()
          this.resetProgressiveUiState()
        }
      }
    },
    /**
     * Excel = misma carga que Search + generar archivo al terminar.
     * Sin data_excel=true ni segundo loader.
     */
    async exportExcel() {
      if (this.isAnyLoading) return
      if (!this.validateForm()) return

      if (!this.filters.start_date || !this.filters.end_date) {
        return this.$refs.toast.warning('Check the dates!')
      }

      const cacheKey = this.getFiltersCacheKey()

      if (this.isSearchCacheValid(cacheKey) && hasAdminDataForExcel(this.tableData)) {
        this.loadingExcel = true
        try {
          this.finalizeExcelExport(this.tableData)
        } finally {
          this.loadingExcel = false
        }
        return
      }

      const monthsBetween = progressiveAdminDataLoader.calculateMonthsBetween(
        this.filters.start_date,
        this.filters.end_date
      )
      const useProgressive = monthsBetween > 1
      const runId = useProgressive ? this.beginProgressiveRun() : null

      this.loadingExcel = true

      try {
        let adminData = null

        if (useProgressive) {
          adminData = await this.loadAdminDataProgressive(runId)
        } else {
          adminData = await this.loadAdminDataSingleRequest()
        }

        if (adminData && (runId == null || runId === this.progressiveRunId)) {
          this.finalizeExcelExport(adminData)
        }
      } catch (err) {
        if (runId == null || runId === this.progressiveRunId) {
          if (String(err?.message) !== 'ABORTED_BY_USER') {
            this.showApiError(err)
          }
        }
      } finally {
        if (runId == null || runId === this.progressiveRunId) {
          progressiveAdminDataLoader.resetFlagsOnly()
          this.resetProgressiveUiState()
        }
      }
    },
    cancelProgressiveLoading() {
      progressiveAdminDataLoader.requestAbort()
      this.progressiveRunId += 1
      progressiveAdminDataLoader.resetFlagsOnly()
      this.resetProgressiveUiState()
    },
    handleFormSubmit() {
      if (this.validateForm()) {
        this.searchFilter()
      }
    },
    validateForm() {
      const { start_date, end_date } = this.filters
      return start_date !== null && end_date !== null
    },
    searchFilter() {
      this.filters.data_excel = false
      if (!this.validateForm()) return null

      this.loadingSearh = true

      if (!this.filters.start_date || !this.filters.end_date) {
        this.resetProgressiveUiState()
        return this.$refs.toast.warning('Check the dates!')
      }

      const monthsBetween = progressiveAdminDataLoader.calculateMonthsBetween(
        this.filters.start_date,
        this.filters.end_date
      )

      if (monthsBetween > 1) {
        this.runProgressiveSearch()
        return
      }

      axios
        .getAdminData({ ...this.filtersForApi(), data_excel: false }, { throwOnError: true })
        .then((response) => {
          this.applyAdminDataResult(this.parseAdminDataResponse(response))
        })
        .catch((error) => {
          this.showApiError(error)
        })
        .finally(() => {
          this.resetProgressiveUiState()
        })
    },
    emitExcel() {
      this.exportExcel()
    },
    resetFilter() {
      const filter = this.filters
      for (const iterator in filter) {
        this.filters[iterator] = null
      }
      this.lastSearchFiltersKey = null
    },
    searchUser({ action, searchQuery, callback }) {
      if (action === 'ASYNC_SEARCH') {
        const datos = {
          name: searchQuery,
        }
        axiosU.userFilter(10, datos).then(({ registro: { data } }) => {
          callback(null, data)
        })
      }
    },
    searchDoctor(args) {
      this.searchUser(args)
    },
  },
}
</script>

<style>
@media (min-width: 970px) {
  .separacion {
    display: none;
  }
}
</style>
